<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form"> 邮箱设置</div>
      
    <el-form-item label="SMTP服务器">
        <el-input placeholder="请输入SMTP服务器" v-model="form.server" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="SMTP服务器端口">
          <el-input placeholder="请输入SMTP服务器端口" v-model="form.domain" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="SMTP用户名">
        <el-input placeholder="请输入SMTP用户名" v-model="form.userName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="SMTP授权码">
          <el-input placeholder="请输入SMTP授权码" v-model="form.emailCode" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="SMTP邮箱">
        <el-input placeholder="请输入SMTP邮箱" v-model="form.email" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="显示名称">
          <el-input placeholder="请输入显示名称" v-model="form.modelName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="邮箱模板">
          <el-input placeholder="请输入邮箱模板" v-model="form.modelEmail" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="">
        
      </el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          server: '',
          domain: '',
          email: '',
          modelName:'',
          userName: '',
          emailCode: '',
          modelEmail:''
        },
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        SettingApi.emailDetail({}, true)
          .then(data => {
            let vars = data.data.vars.values;
            self.form.server = vars.emailModel.server;
            self.form.domain = vars.emailModel.domain;
            self.form.email = vars.emailModel.email;
            self.form.emailCode = vars.emailModel.emailCode;
            self.form.userName = vars.emailModel.userName;
            self.form.modelName = vars.emailModel.modelName;
            self.form.modelEmail = vars.emailModel.modelEmail;
          })
          .catch(error => {});

      },
      //提交表单
      onSubmit() {
        let self = this;
        let params = self.form;
        let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
				if (!reg.test(self.form.email)&&self.form.email) {
          self.$message({
              message: '邮箱有误,请重填',
              type: 'error'
            });
					return;
				}
        self.loading = true;
        SettingApi.editEmail(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，邮箱通知设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/email/index.vue